import { gql } from '@apollo/client'

/** 咒语tag列表 */
export const GET_GENERATOR_TAGS = gql`
  query getGeneratorTags {
    aiArtworkResourceModule {
      spellTab(param: { site: PC }) {
        id
        name
        tags: child {
          id
          englishName
          name
          spellLabel
        }
      }
    }
  }
`
/** tag大全 */
export const GET_TOTAL_TAGS = gql`
  query getTotalTags($param: TagQueryInput, $first: Int, $offset: Int) {
    aiArtworkResourceModule {
      searchTag(param: $param, page: { first: $first, offset: $offset }) {
        edges {
          node {
            id
            englishName
            name
            frequency
            spellLabel
          }
        }
        pageInfo {
          totalCount
        }
      }
    }
  }
`

/** 咒语解析 */
export const CREATE_IMG_TO_TAG = gql`
  mutation createImg2Tag($param: SpellAnalysisCreateInput) {
    spellAnalysisMutation {
      id: create(input: $param)
    }
  }
`

/** 咒语解析详情 */
export const IMG_TO_TAG_DETAIL = gql`
  query img2TagDetail($id: Long!) {
    spellAnalysisQuery {
      details(id: $id) {
        generateStatus
        id
        imageUrl
        tags
        chineseTags
        imageWidth
        imageHeight
        ucTags
        chineseUcTags
        otherParams
        failMessage
        promptList
        size
        model
        multiTags {
          tag
          tagType
        }
      }
    }
  }
`

/** 咒语解析列表 */
export const IMG_TO_TAG_LIST = gql`
  query img2TagList(
    $first: Int = 40
    $offset: Int = 0
    $model: AiCreateArtworkModel
  ) {
    spellAnalysisQuery {
      list(model: $model, page: { first: $first, offset: $offset }) {
        edges {
          node {
            generateStatus
            id
            imageUrl
            imageWidth
            imageHeight
            model
            tags
            chineseTags
            promptList
            generationTime
            size
            failMessage
            multiTags {
              tag
              tagType
            }
          }
        }
        pageInfo {
          hasNextPage
          totalCount
        }
      }
    }
  }
`

/** 增加tag使用频率 */
export const UPDATE_TAG_COUNT = gql`
  mutation updateTagCount($param: TagFrequencyInput) {
    wjAiModule {
      incrTagFrequency(param: $param)
    }
  }
`

/** tag大全分类 */
export const GET_TAGS_CATEGORY = gql`
  query getTagsCategory($param: TagCategoryQueryInput) {
    aiArtworkResourceModule {
      tagCategoryList(param: $param) {
        id
        name
        model
        modelCode
        visible
      }
    }
  }
`
